import * as blocLiensStyles from '../../../styles/admissions/admissions.module.scss';
import { PropTypes } from 'prop-types';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React from 'react';
import clsx from 'clsx';
import {faCircle} from '@fortawesome/free-regular-svg-icons';

const KeyFigureList = ({title, figures, color}) => {
  return (
    <>
      <div
        className={clsx(blocLiensStyles.contentTitleInfo, {
          [blocLiensStyles.darkBlocLiensEntete]: color === 'BLACK',
          [blocLiensStyles.redBlocLiensEntete]: color !== 'BLACK'
        })}
      >
        <div className={blocLiensStyles.itemTitleKeyFigure}>
          <h2 className={blocLiensStyles.relatedKeyFigureTitle}>
            {title}
          </h2>
        </div>
      </div>
      <div
        className={clsx(blocLiensStyles.contentKeyFigure, {
          [blocLiensStyles.darkActionListCorps]: color === 'BLACK',
          [blocLiensStyles.redActionListCorps]: color !== 'BLACK'
        })}
      >
        <ul>
          {figures?.map((figure, index, arr) => {
            return (
              <li className={blocLiensStyles.list}
                key={index}
              >
                <div
                  className={clsx({[blocLiensStyles.margin]: index < arr.length - 1})}
                >
                  <p
                    className={clsx(blocLiensStyles.typoSpacing, blocLiensStyles.numberKeyfigure)}
                  >
                    <FontAwesomeIcon
                      className={blocLiensStyles.puceKeyFigure}
                      icon={faCircle}
                    />
                    {figure.label}
                  </p>
                  <p
                    className={blocLiensStyles.typovalue}
                  >
                    {figure.value}
                  </p>
                </div>
                {index < arr.length - 1
              && (
                <div
                  className={clsx(blocLiensStyles.dividerContent,
                    blocLiensStyles.separation,
                    blocLiensStyles.margin)}
                >
                </div>
              )}
              </li>);
          })}
        </ul>
      </div>
    </>
  );
};

KeyFigureList.propTypes = {
  color: PropTypes.oneOf(['BLACK', 'RED']),
  figures: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  })),
  title: PropTypes.string.isRequired,
};

export default KeyFigureList;
